import type { ImageWithUrls } from './image';

export type FeedbackStatus = 'pending' | 'replied';

export interface FeedbackItem {
  id: number;
  userId: number;
  content: string;
  images: ImageWithUrls[];
  adminReply: string | null;
  repliedAt: string | null;
  repliedBy: number | null;
  repliedByUsername: string | null;
  status: FeedbackStatus;
  createdAt: string;
}

export interface FeedbackListItemForAdmin extends FeedbackItem {
  user: {
    id: number;
    nickname: string | null;
    avatarAccessUrl: string | null;
    openId: string;
  };
}

export interface FeedbackSummary {
  total: number;
  pending: number;
  replied: number;
}

export interface CreateFeedbackRequest {
  content: string;
  imageIds?: number[];
}

export interface ReplyFeedbackRequest {
  adminReply: string;
}

export const FEEDBACK_CONTENT_MAX_LEN = 1000;
export const FEEDBACK_IMAGE_MAX_COUNT = 3;
